import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormDropDownList } from "../FormComponents";
import { requiredValidator } from "../Validators";
import { useState, useEffect } from "react";

import { getWorktypeGroupDropdown } from "../../../data/workTypeGroupData";
import { dropDown, postWorktypeTypesFormik } from "../../../data/interfaces";

import { useFormik } from 'formik';
import { useToast } from '../../../contexts/ToastContext'
import { getTargetWorktype } from "../../../data/worktypeData";
import { addWorkTypeFormik, updateWorkTypeFormik } from '../../../data/worktypeData'
import SkeletonForm from "../../Skeletons/SkeletonForm";

const AddWorkTypeForm = (props: any) => {
  const [workTypeGroups, setWorkTypeGroups] = useState<dropDown[]>([]);

  const handleSubmit = (dataItem: any) => {
    props.onWorkTypeSubmit(dataItem);
    // console.log(dataItem);
  };

  const fetchWorkTypeGroupData = async () => {
    const worktypeData = await getWorktypeGroupDropdown();
    setWorkTypeGroups(worktypeData);
  };

  useEffect(() => {
    fetchWorkTypeGroupData();
  }, []);

  return (
    <Form
      onSubmit={handleSubmit}
      render={(formRenderProps) => (
        <FormElement style={{ padding: "1rem", marginBottom: "5rem" }}>
          <fieldset className={"k-form-fieldset"}>
            <div className="form__subtitle">
              Add work type details:
              <button
                className="form__reset__button"
                onClick={formRenderProps.onFormReset}
              >
                Clear fields
              </button>
            </div>

            <Field
              data={workTypeGroups}
              name={"worktypeGroupId"}
              component={FormDropDownList}
              label={"Choose the group:"}
            />

            <Field
              name={"description"}
              component={FormInput}
              label={"Description: "}
              placeholder={"Enter a description:"}
              validator={requiredValidator}
            />
          </fieldset>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "1rem 2rem 1rem 2rem",
              position: "absolute",
              zIndex: "10000",
            }}
          >
            <button
              type={"submit"}
              disabled={!formRenderProps.allowSubmit}
              style={{
                width: "100%",
                marginTop: "0.5rem",
                height: "3rem",
                backgroundColor: "rgb(174 199 65)",
                color: "rgb(71 83 21)",
                border: 0,
                borderRadius: "0.3rem",
              }}
            >
              Add work type
            </button>
          </div>
        </FormElement>
      )}
    />
  );
};

// const WorkTypeForm = (props: any) => {
//   const { showToast } = useToast()
//   const [workTypeGroups, setWorkTypeGroups] = useState<dropDown[]>([]);

//   const [initialValues, setInitialValues] = useState<postWorktypeTypesFormik>({
//     description: '',
//     worktypeGroupId: 0
//   });

//   const fetchWorkTypeGroupData = async () => {
//     const worktypeData = await getWorktypeGroupDropdown();
//     setWorkTypeGroups(worktypeData);
//   };

//   const editMode = props.onWorktypeId > 0;
//   const fetchEditInitialValues = async () => {
//     const worktype = await getTargetWorktype(props.onWorktypeId);
//     setInitialValues({
//       description: worktype.description,
//       worktypeGroupId: worktype.worktypegroupId,
//     });
//   }

//   const submitWorkType = async (values: any) => {
//     var responseDesc = '';
//     if (editMode) {
//       await updateWorkTypeFormik(values, props.onWorktypeId).then((resp) => {
//         responseDesc = resp.description;
//       });
//     }
//     else {
//       await addWorkTypeFormik(values).then((resp) => {
//         responseDesc = resp.description;          
//       });        
//     }

//     if (responseDesc.length > 0) {
//       showToast("Worktype succesfully added", "success");
//       props.onSuccess();
//     } else {
//       showToast("An error occurred creating saving the work type", "error");
//     }
//   }

//   useEffect(() => {
//     fetchWorkTypeGroupData();
    
//     if (editMode) {
//       fetchEditInitialValues();
//     }
//   }, []);

//   const formik = useFormik({
//     initialValues: initialValues,
//     enableReinitialize: true,
//     onSubmit: (values: postWorktypeTypesFormik) => {
//       submitWorkType(values);
//     },
//   });

//   return (
//     <form onSubmit={formik.handleSubmit}>
//       <div>
//         <label htmlFor="WorkType Group">Choose the group:</label>
//         <select
//           name="worktypeGroupId"
//           id="worktypeGroupId"
//           value={formik.values.worktypeGroupId}
//           onChange={formik.handleChange}
//           disabled={editMode}
//         >
//           <option value="0"></option>
//           {workTypeGroups.map((group, idx) => <option key={idx} value={group.value}>{group.text}</option> )}
//         </select>
//       </div>
//       <div>
//         <label htmlFor="description">Description</label>
//         <input
//           id="description"
//           name="description"
//           type="text"
//           onChange={formik.handleChange}
//           value={formik.values.description}
//         />
//       </div>
//       <button
//         type="submit"
//         className="submitBtn"
//       >Submit</button>
//     </form>
//   );
// }

export default AddWorkTypeForm;
